module.exports = __webpack_public_path__ + "3aa67c96da07514a1ac7001b4bc39d61.pdf";